import { render, staticRenderFns } from "./MasterCampaignList.vue?vue&type=template&id=461e55b8&"
import script from "./MasterCampaignList.vue?vue&type=script&lang=js&"
export * from "./MasterCampaignList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports